import React from "react";
import { Accordion } from "react-bootstrap";
import styles from "./index.module.scss";
import { AssetStore } from "../../assets/AssetsStore";
import Assets from "../Layout/Assets";
import { Drawer } from "antd";

function DashboardNavbar({
  onItemClick,
  activeNavItem,
  navData,
  theme,
  isDoctor,
  isDrawerOpen = false,
  setDrawerClose = () => {},
}) {
  const getIconStyle = () => {
    return {
      color: theme?.secondary,
    };
  };

  const getActiveListItemStyle = () => {
    return {
      backgroundColor: "#314f7c",
      color: "#fff",
    };
  };

  const getNavBarStyle = () => {
    return {
      backgroundColor: theme?.primary,
      color: "#fff",
    };
  };
  const userData = JSON.parse(localStorage.getItem("userData"));

  return (
    <>
      <div className={styles.container} style={getNavBarStyle()}>
        <div className={styles.navBarHeader}>
          <div className={styles.navBarProfileWrap}>
            <div className={styles.navBarProfile}>
              <h5>{userData?.profileName}</h5>
              <span>{userData?.mobileNumber}</span>
            </div>
            <span className={styles.caption}>
              {isDoctor
                ? userData?.specialityName != ""
                  ? userData?.specialityName
                  : ""
                : "Patient ID :" + userData?.profileId}
            </span>
          </div>

          <Accordion
            defaultActiveKey={[1]}
            className={styles.side_nav_accordion_interbranch}
          >
            {navData &&
              navData.length &&
              navData.map((object, menuKey) => {
                if (object?.tittle) {
                  return (
                    <Accordion.Item key={menuKey} eventKey={menuKey}>
                      <Accordion.Header>
                        <div className={styles.list_tittle}>
                          {object.tittle}
                        </div>
                      </Accordion.Header>

                      {object.options.map((element, optionKey) => {
                        return (
                          <Accordion.Body
                            onClick={() => {
                              element.isContact ?? onItemClick(element.name);
                            }}
                            style={
                              activeNavItem === element?.name
                                ? getActiveListItemStyle()
                                : {}
                            }
                            key={optionKey}
                          >
                            <div className="icon" style={getIconStyle()}>
                              {element?.isContact ? (
                                <img src={element.ico} alt="ico" />
                              ) : (
                                element.ico
                              )}
                            </div>
                            <div className={styles.itemName}>
                              {element?.isContact ? (
                                <a href={element?.href}>{element.name}</a>
                              ) : (
                                element.name
                              )}
                            </div>
                          </Accordion.Body>
                        );
                      })}
                    </Accordion.Item>
                  );
                } else {
                  return (
                    <>
                      {object.options.map((element, optionKey) => {
                        if (element?.name !== "Prescription") {
                          return (
                            <button
                              key={`selarated_${optionKey}`}
                              onClick={() => {
                                onItemClick(element.name);
                              }}
                              style={
                                activeNavItem === element?.name
                                  ? getActiveListItemStyle()
                                  : {}
                              }
                              className={`${styles.separated_nav_button}`}
                            >
                              <div className="icon" style={getIconStyle()}>
                                {element.ico}
                              </div>
                              <div className="text">{element?.name}</div>
                            </button>
                          );
                        }
                      })}
                    </>
                  );
                }
              })}
          </Accordion>
        </div>

        <div className={styles.navBarFooter}>
          <img
            className={styles.brandLogo}
            src={AssetStore.gangaAppLogo}
            alt="ganga_logo"
          />

          <div className={styles.footerBody}>
            <h5>DOWNLOAD OUR APP</h5>
            <p>The quickest and easiest way to connect with us.</p>

            <div className={styles.appStoreImages}>
              <a
                href="https://play.google.com/store/apps/details?id=com.neevlabs.ganga"
                target="_blank"
              >
                <img src={Assets.playStore} alt="" />
              </a>
              <a
                href="https://apps.apple.com/in/app/ganga-telemedicine/id6461049457"
                target="_blank"
              >
                {" "}
                <img src={Assets.app_store_icon} alt="" />
              </a>
            </div>
          </div>
        </div>
      </div>

      <Drawer
        className={styles.drawer}
        size="small"
        title={false}
        placement="left"
        onClose={setDrawerClose}
        open={isDrawerOpen}
      >
        <div className={styles.container} style={getNavBarStyle()}>
          <div className={styles.navBarHeader}>
            <div className={styles.navBarProfileWrap}>
              <div className={styles.navBarProfile}>
                <h5>{userData?.profileName}</h5>
                <span>{userData?.mobileNumber}</span>
              </div>
              <span className={styles.caption}>
                {isDoctor
                  ? userData?.specialityName != ""
                    ? userData?.specialityName
                    : ""
                  : "Patient ID :" + userData?.profileId}
              </span>
            </div>

            <Accordion
              defaultActiveKey={[1]}
              className={styles.side_nav_accordion_interbranch}
            >
              {navData &&
                navData.length &&
                navData.map((object, menuKey) => {
                  if (object?.tittle) {
                    return (
                      <Accordion.Item key={menuKey} eventKey={menuKey}>
                        <Accordion.Header>
                          <div className={styles.list_tittle}>
                            {object.tittle}
                          </div>
                        </Accordion.Header>

                        {object.options.map((element, optionKey) => {
                          return (
                            <Accordion.Body
                              onClick={() => {
                                element.isContact ?? onItemClick(element.name);
                              }}
                              style={
                                activeNavItem === element?.name
                                  ? getActiveListItemStyle()
                                  : {}
                              }
                              key={optionKey}
                            >
                              <div className="icon" style={getIconStyle()}>
                                {element?.isContact ? (
                                  <img src={element.ico} alt="ico" />
                                ) : (
                                  element.ico
                                )}
                              </div>
                              <div className={styles.itemName}>
                                {element?.isContact ? (
                                  <a href={element?.href}>{element.name}</a>
                                ) : (
                                  element.name
                                )}
                              </div>
                            </Accordion.Body>
                          );
                        })}
                      </Accordion.Item>
                    );
                  } else {
                    return (
                      <>
                        {object.options.map((element, optionKey) => {
                          if (element?.name !== "Prescription") {
                            return (
                              <button
                                key={`selarated_${optionKey}`}
                                onClick={() => {
                                  onItemClick(element.name);
                                }}
                                style={
                                  activeNavItem === element?.name
                                    ? getActiveListItemStyle()
                                    : {}
                                }
                                className={`${styles.separated_nav_button}`}
                              >
                                <div className="icon" style={getIconStyle()}>
                                  {element.ico}
                                </div>
                                <div className="text">{element?.name}</div>
                              </button>
                            );
                          }
                        })}
                      </>
                    );
                  }
                })}
            </Accordion>
          </div>

          <div className={styles.navBarFooter}>
            <img
              className={styles.brandLogo}
              src={AssetStore.gangaAppLogo}
              alt="ganga_logo"
            />

            <div className={styles.footerBody}>
              <h5>DOWNLOAD OUR APP</h5>
              <p>The quickest and easiest way to connect with us.</p>

              <div className={styles.appStoreImages}>
                <a
                  href="https://play.google.com/store/apps/details?id=com.neevlabs.ganga"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img src={Assets.playStore} alt="" />
                </a>
                <a
                  href="https://apps.apple.com/in/app/ganga-telemedicine/id6461049457"
                  target="_blank"
                  rel="noreferrer"
                >
                  {" "}
                  <img src={Assets.app_store_icon} alt="" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </Drawer>
    </>
  );
}

export default DashboardNavbar;
